import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.965 14.093h-3.93a2.754 2.754 0 0 1-2.751-2.751V4.658a2.754 2.754 0 0 1 2.751-2.751h3.93a2.754 2.754 0 0 1 2.751 2.751v6.684a2.754 2.754 0 0 1-2.751 2.751ZM6.035 3.407a1.253 1.253 0 0 0-1.251 1.251v6.684a1.253 1.253 0 0 0 1.251 1.251h3.93a1.253 1.253 0 0 0 1.251-1.251V4.658a1.253 1.253 0 0 0-1.251-1.251Zm1.921 1.158a1.058 1.058 0 1 0 1.035 1.057 1.046 1.046 0 0 0-1.035-1.057Zm2.277 4.693v-.006a.353.353 0 0 0-.352-.352H6.1a.353.353 0 0 0-.352.352v.006a.353.353 0 0 0 .352.352h3.78a.353.353 0 0 0 .353-.352Zm0 1.815v-.007a.353.353 0 0 0-.352-.352H6.1a.353.353 0 0 0-.352.352v.007a.353.353 0 0 0 .352.352h3.78a.353.353 0 0 0 .353-.352Z';
const draw24px =
  'M7.936,17.125V16.98a.565.565,0,0,1,.563-.563h6.9a.565.565,0,0,1,.563.563v.145a.565.565,0,0,1-.563.564H8.5A.565.565,0,0,1,7.936,17.125ZM8.5,14.441h6.9a.565.565,0,0,0,.563-.564v-.145a.564.564,0,0,0-.563-.563H8.5a.564.564,0,0,0-.563.563v.145A.565.565,0,0,0,8.5,14.441Zm3.4-4.151A2.061,2.061,0,1,0,9.879,8.229,2.039,2.039,0,0,0,11.9,10.29ZM4.3,4.681A2.754,2.754,0,0,1,7.047,1.93h9.835a2.754,2.754,0,0,1,2.751,2.751V19.319a2.754,2.754,0,0,1-2.751,2.751H7.047A2.754,2.754,0,0,1,4.3,19.319ZM5.8,19.319A1.252,1.252,0,0,0,7.047,20.57h9.835a1.252,1.252,0,0,0,1.251-1.251V4.681A1.252,1.252,0,0,0,16.882,3.43H7.047A1.252,1.252,0,0,0,5.8,4.681Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PropertiesIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'properties'),
) as IconWithRender;

PropertiesIcon.displayName = 'PropertiesIcon';
PropertiesIcon.propTypes = Icon.propTypes;
PropertiesIcon.renderIcon = (props) => <PropertiesIcon {...props} />;
export default PropertiesIcon;
